type ListItem = {
  label?: string;
  description?: string;
};

type ListProps = {
  items: (string | ListItem)[];
  variant?: "check" | "plain";
  className?: string;
};

function isContentItem(item: string | ListItem): item is ListItem {
  return typeof item === "object";
}

export function List({ items, variant = "check", className = "" }: ListProps) {
  return (
    <ul className={`space-y-3 ${className}`.trim()}>
      {items.map((item, index) => {
        const normalized = isContentItem(item) ? item : { label: item };

        return (
          <li key={`${normalized.label ?? "item"}-${index}`} className="flex gap-3">
            {variant === "check" ? (
              <span aria-hidden="true" className="mt-1 text-mint-dark">
                ✓
              </span>
            ) : (
              <span aria-hidden="true" className="mt-2 size-1.5 rounded-full bg-brand-700" />
            )}
            <span>
              {normalized.label ? (
                <strong className="font-semibold">{normalized.label}</strong>
              ) : null}
              {normalized.label && normalized.description ? " — " : null}
              {normalized.description ? (
                <span className="text-ink-soft">{normalized.description}</span>
              ) : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
